import { useQuery } from '@tanstack/react-query';
import { userApi } from '../api/userApi';
import type { UserSearchCondition } from '../types/user';

/**
 * GET /api/eraf/users — 사용자 목록 조회 (페이징/검색/필터/정렬)
 * queryKey: ['user-management', 'list', filters]
 */
export function useUserList(filters: UserSearchCondition) {
  return useQuery({
    queryKey: ['user-management', 'list', filters],
    queryFn: () => userApi.list(filters),
    staleTime: 30_000,
  });
}
